import * as Yup from 'yup'
import LookupType from './LookupType'

export const PebbleDailyWorkOrderSchema = Yup.object().shape({
    id: Yup.number().nullable(),
    job_id: Yup.number().nullable(),
    job_detail_id: Yup.number().nullable(),

    company: LookupType.nullable(),
    job_name: Yup.string().nullable(),
    date: Yup.string().nullable(),
    
    address_line_1: Yup.string().nullable(),
    city: Yup.string().nullable(),
    zip_code: Yup.string().nullable(),
    key_map: Yup.string().nullable(),

    mmg_distance: Yup.string().nullable(),
    manchaca_distance: Yup.string().nullable(),
    
    detail_wash_acid_wash: Yup.string().nullable(),
    slurry: Yup.string().nullable(),
    prep: Yup.string().nullable(),
    remodel: Yup.string().nullable(),
    repairs: Yup.string().nullable(),
    others: Yup.string().nullable(),

    driver_name: Yup.string().nullable(),
    driver_in: Yup.string().nullable(),
    on_job: Yup.string().nullable(),
    break_start: Yup.string().nullable(),
    break_end: Yup.string().nullable(),
    leave_job: Yup.string().nullable(),
    driver_out: Yup.string().nullable(),

    color: LookupType.nullable(),
    multi_coat: Yup.string().nullable(),
    rolls_of_duct_tape: Yup.string().nullable(),
    rolls_of_plastic: Yup.string().nullable(),
    marble_sand: Yup.string().nullable(),
    acid: Yup.string().nullable(),
    waterproofing: Yup.string().nullable(),
    white_cement: Yup.string().nullable(),
    gray_cement: Yup.string().nullable(),
    water_stop: Yup.string().nullable(),

    material_types: Yup.array().of(LookupType).nullable(),

    mmg_ia: Yup.string().nullable(),
    plan_ia: Yup.string().nullable(),

    workers: Yup.array().of(LookupType).nullable(),
    workers_other_1: Yup.string().nullable(),
    workers_other_2: Yup.string().nullable(),
    workers_other_3: Yup.string().nullable(),
})